const currentPage = {
	state: {
		currentPage: 1,
        scrollPosition: { x: 0, y: 0 },
        pageBreederId: null,
	},
	mutations: {
		setCurrentPage(state, page) {
            state.currentPage = page;
        },
        clearCurrentPage(state) {
            state.currentPage = 1
        },
        clearCurrentPosition(state) {
            state.scrollPosition = { x: 0, y: 0 }
        },
        clearPageBreederId(state) {
            state.pageBreederId = null
        },
        setScrollPosition(state, position) {
            state.scrollPosition = position
        },
        setPageBreederId(state, pageBreederId) {
            state.pageBreederId = pageBreederId
        }
	},
    getters: {
		getCurrentPage(state) {
			return state.currentPage;
		},
        getCurrentPosition(state) {
			return state.scrollPosition;
		},
        getPageBreederId(state) {
			return state.pageBreederId;
		}
	}
	
}

export default currentPage;